// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bg_MVtVs {
  background-color: transparent;
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
}
.OptionsPopupContainer_u4R63 {
  flex-direction: column;
  justify-content: center;
  gap: 8px;
  align-items: center;
  border-radius: 12px;
  position: relative;
  background-color: var(--white-background);
  padding: 5px;
  min-width: fit-content;
  z-index: 99;
  top: 20px;
  right: 0;
  background: var(--white-background);
  border-radius: 8px;
  box-shadow: 0 2px 10px var(--_0000001a-shadow);
  width: 160px;
  z-index: 9999;
  padding: 4px;
  > div {
    width: 100%;
    padding: 8px 16px;
    box-sizing: border-box;
    border: none;
    background: none;
    text-align: left;
    cursor: pointer;
    font-size: 14px;
    color: var(--_3-color);
    border-radius: 4px;
    display: flex;
    align-items: center;
    gap: 5px;
    transition: background-color 0.2 sease-in-out;
    &:hover {
      background-color: var(--f5-background);
    }
  }
  .askAi_jL3nS{
    background: var(--e4fff9-background);
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/OptionsPopup/OptionsPopup.module.css"],"names":[],"mappings":"AAAA;EACE,6BAA6B;EAC7B,YAAY;EACZ,aAAa;EACb,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;AACd;AACA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,yCAAyC;EACzC,YAAY;EACZ,sBAAsB;EACtB,WAAW;EACX,SAAS;EACT,QAAQ;EACR,mCAAmC;EACnC,kBAAkB;EAClB,8CAA8C;EAC9C,YAAY;EACZ,aAAa;EACb,YAAY;EACZ;IACE,WAAW;IACX,iBAAiB;IACjB,sBAAsB;IACtB,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,6CAA6C;IAC7C;MACE,sCAAsC;IACxC;EACF;EACA;IACE,oCAAoC;EACtC;AACF","sourcesContent":[".bg {\n  background-color: transparent;\n  width: 100vw;\n  height: 100vh;\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 999;\n}\n.OptionsPopupContainer {\n  flex-direction: column;\n  justify-content: center;\n  gap: 8px;\n  align-items: center;\n  border-radius: 12px;\n  position: relative;\n  background-color: var(--white-background);\n  padding: 5px;\n  min-width: fit-content;\n  z-index: 99;\n  top: 20px;\n  right: 0;\n  background: var(--white-background);\n  border-radius: 8px;\n  box-shadow: 0 2px 10px var(--_0000001a-shadow);\n  width: 160px;\n  z-index: 9999;\n  padding: 4px;\n  > div {\n    width: 100%;\n    padding: 8px 16px;\n    box-sizing: border-box;\n    border: none;\n    background: none;\n    text-align: left;\n    cursor: pointer;\n    font-size: 14px;\n    color: var(--_3-color);\n    border-radius: 4px;\n    display: flex;\n    align-items: center;\n    gap: 5px;\n    transition: background-color 0.2 sease-in-out;\n    &:hover {\n      background-color: var(--f5-background);\n    }\n  }\n  .askAi{\n    background: var(--e4fff9-background);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"bg": `bg_MVtVs`,
	"OptionsPopupContainer": `OptionsPopupContainer_u4R63`,
	"askAi": `askAi_jL3nS`
};
export default ___CSS_LOADER_EXPORT___;
